"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.errorEmitter = exports.init = exports.reset = void 0;
var emitter; // For unit testing purposes:

var reset = function reset() {
  emitter = undefined;
};

exports.reset = reset;

var init = function init(appErrorHandler) {
  // Use the app's error handler if available, then fall back to console.error:
  // eslint-disable-next-line no-console
  emitter = appErrorHandler || console.error;
};

exports.init = init;

var errorEmitter = function errorEmitter(err) {
  if (!emitter) {
    // Make sure error emitter has been initiated before it executes the first time.
    init();
  } // Casting this, as TS thinks it would be possible for it to be undefined:


  emitter(err);
};

exports.errorEmitter = errorEmitter;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/rio-sdk-web/dist/cjs/utils/errorEmitter.js
// module id = 1351
// module chunks = 11